import React from 'react'

var NotFound = () => "~"

export default NotFound
